export function parseDate(dateStr) {
  if (!dateStr) {
    return null;
  }
  const [date] = dateStr.split(' ');

  if (date.includes('/')) {
    const [month, day, year] = date.split('/');
    return new Date(`${year}-${month}-${day}T00:00:00`);
  }

  return new Date(`${date}T00:00:00`);
}
